import Menu from '../../components/menu';
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './style.scss';

const AboutUs: React.FC = () => {
	const [paragraphs, setParagraphs] = useState<string[]>([]);

	useEffect(() => {
		fetch('/aboutus.json')
			.then(response => response.json())
			.then(data => setParagraphs(data.paragraphs));
	}, []);

	return (
		<div className="about-us-container">
			<Menu />
			<section className="about-us">
				<motion.h2
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: false, amount: 0.25 }}
					transition={{ duration: 0.5, delay: 0.2 }}
				>
					About Us
				</motion.h2>
				{paragraphs.map((text, index) => (
					<motion.p
						key={index}
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: false, amount: 0.25 }}
						transition={{ duration: 0.5, delay: 0.4 }}
						dangerouslySetInnerHTML={{ __html: text }}
					/>
				))}
			</section>
		</div>
	);
};

export default AboutUs;
